import axios from 'axios'
import store from '@/store/index';

// 创建 axios 实例
const request = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://bwp.panyuwater.cn'
})

// 请求拦截器
request.interceptors.request.use(config => {

    if (store.state.accountInfo != null) {
        const json = {
            accountId: store.state.accountInfo.accountId,
            token: store.state.accountInfo.token
        }
        config.headers['Authentication-Info'] = JSON.stringify(json);
    }

    return config;
    
});

export default request